import http from './base/http';
// 在用项目点管理列表
export function formalProjectList(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10001',
    OTYPE: 4,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: sessionStorage.getItem('companyId'),
    ...data,
  };
  return http.post(params);
}
// 新增在用项目点
export function addFormalProjectList(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10001',
    OTYPE: 1,
    TC_ID: parseInt(sessionStorage.getItem('companyId')),
    ...data,
  };
  return http.post(params);
}
// 修改在用项目点
export function editFormalProjectList(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 人员分配
export function allotFormalProjectList(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 禁用项目点
export function stopFormalProjectList(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取负责人
export function getUser(data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 7,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: sessionStorage.getItem('companyId'),
    ...data,
  };
  return http.post(params);
}
// 查询负责人姓名
export function getName(data) {
  const params = {
    SERVICE_ID: '10002',
    OTYPE: 8,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取临时项目点列表
export function temporaryProjectList(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 6,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: sessionStorage.getItem('companyId'),
    ...data,
  };
  return http.post(params);
}
// 启用临时项目点
export function startProjectList(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 7,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取所有甲方人员
export function getAllPartyPer(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 8,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    TC_ID: sessionStorage.getItem('companyId'),
    ...data,
  };
  return http.post(params);
}
// 获取某个项目点的甲方人员
export function getPartyPer(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 6,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 提交某个项目点甲方人员的配置
export function submitPartyAllot(data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 7,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/projectSite.js